module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-1.0fa6bbaa.svg";